// extracted by mini-css-extract-plugin
export default {"oosPopoverWrapper":"Io-z","slideIn":"Jo-z"};